import { render, staticRenderFns } from "./QuizStudentFinalScore.vue?vue&type=template&id=ba579d16&"
import script from "./QuizStudentFinalScore.vue?vue&type=script&lang=js&"
export * from "./QuizStudentFinalScore.vue?vue&type=script&lang=js&"
import style0 from "./QuizStudentFinalScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports